import {
  MOSCOW_ID,
  MOSCOW_AREA_ID,
  MOSCOW_AND_MOSCOW_AREA_ID,
  SPB_ID,
  LO_ID,
  SPB_AND_LO_ID,
} from '../../constants/geo';
import { IRegion } from '../../types/regions';

export function isMoscowAndMoscowArea(region?: IRegion) {
  return region?.id === MOSCOW_AND_MOSCOW_AREA_ID;
}

export function isSPBAndLo(region?: IRegion) {
  return region?.id === SPB_AND_LO_ID;
}

export function isMoscowOrMoscowArea(regionOrId?: IRegion | number): boolean {
  if (typeof regionOrId === 'undefined') {
    return false;
  }

  const id = typeof regionOrId === 'number' ? regionOrId : regionOrId.id;

  return [MOSCOW_ID, MOSCOW_AREA_ID, MOSCOW_AND_MOSCOW_AREA_ID].includes(id);
}

export function isSBPOrLo(regionOrId?: IRegion | number): boolean {
  if (typeof regionOrId === 'undefined') {
    return false;
  }

  const id = typeof regionOrId === 'number' ? regionOrId : regionOrId.id;

  return [SPB_ID, LO_ID, SPB_AND_LO_ID].includes(id);
}
